import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { parse } from 'date-fns';
import DatePicker from '../DatePicker/index';
import {
  GE,
  LE,
  getMinToDate,
  getMaxFromDate,
  handleApply,
  handleFilterChange,
  handleFromToDateChange,
  handleReset,
} from './tableFilters';

import styles from './TableFilters.module.scss';


const InsurancesTableFilters = ({
  locFilters,
  setLocFilters,
  dateRange,
  setDateRange,
  filters,
  setFilters,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.filter_block)}>
      <div className={styles.filter_inputs}>
        <div className={styles.filter_col}>
          <input
            type="text"
            name="masysId"
            value={locFilters.masysId || ''}
            onChange={(e) => handleFilterChange(e, locFilters, setLocFilters)}
            placeholder={t('insuranceList.contractNumber')}
          />
        </div>
        <div className={styles.filter_col}>
          <DatePicker
            className={styles.dateInput}
            date={
              dateRange[GE]
              && parse(dateRange[GE], 'dd-MM-yyyy', new Date())
            }
            name="fromDate"
            onDateChange={(date) => handleFromToDateChange(date, GE, dateRange, setDateRange)}
            maxDate={getMaxFromDate(dateRange)}
            placeholderText={t('customTbl.filters.from')}
            dateInputProps={{ icon: 'calendar' }}
          />
        </div>

        <div className={styles.filter_col}>
          <DatePicker
            className={styles.dateInput}
            date={
              dateRange[LE]
              && parse(dateRange[LE], 'dd-MM-yyyy', new Date())
            }
            name="toDate"
            onDateChange={(date) => handleFromToDateChange(date, LE, dateRange, setDateRange)}
            minDate={getMinToDate(dateRange)}
            placeholderText={t('customTbl.filters.to')}
            dateInputProps={{ icon: 'calendar' }}
          />
        </div>

        <div className={styles.filter_col}>
          <input className={styles.invisibleInput} type="text" />
        </div>
      </div>

      <div className={styles.filter_buttons}>
        <button
          type="button"
          className={cn(styles.reset_btn, 'white_button')}
          onClick={() => handleReset(dateRange, filters, setFilters, setLocFilters, setDateRange)}
        >
          {t('customTbl.filters.reset')}
        </button>
        <button
          type="button"
          className={cn(styles.apply_btn, 'blue_button')}
          onClick={() => handleApply(dateRange, locFilters, setFilters)}
        >
          {t('customTbl.filters.apply')}
        </button>
      </div>
    </div>
  );
};

InsurancesTableFilters.propTypes = {
  locFilters: PropTypes.shape({
    contractId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    mobilePhone: PropTypes.string,
    amount: PropTypes.string,
    masysId: PropTypes.string,
    details: PropTypes.string,
  }).isRequired,
  dateRange: PropTypes.shape({
    LE: PropTypes.string,
    GE: PropTypes.string,
  }).isRequired,
  filters: PropTypes.shape({}).isRequired,
  setLocFilters: PropTypes.func.isRequired,
  setDateRange: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
};

export default InsurancesTableFilters;
